var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#print_svg__pattern0_5426_1898)",
    d: "M0 0h16v16H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "print_svg__pattern0_5426_1898",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#print_svg__image0_5426_1898",
    transform: "scale(.0303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "print_svg__image0_5426_1898",
    width: 33,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIaADAAQAAAABAAAAIQAAAAAWQIAAAAABe0lEQVRYCe1W0VHDMAwNHAOUPz67AdmAEegmjIBHCJvACGxQ/vhlgpYJ4L008sk9WQHjmn5Ed6osWXp6URxfuy4vAVs76FclHYBjyoUZPQTZvKbsAXZtAbYkwf5mvyuLmREzi408KzQ70UurqnVsISETXyZxVpPQn+gKzO6gvTBU9lGt/7IUnC1AXqG8wKJssKp5RfNumFP2Y99RevzOFZxyv+dN+Ay9H+l03cfk72FvoGvoO5R+qVg4G4DdToAvtPo1rKeNU5seDWS6O06Cjgj9VhL7LpeVjNybRECSPi/yDkvtIE2PrXcm4js7Lir0+YXpf1YRvyUJctcHP5LQ17b3gLrYy7P2YjNrkzHvTORqasRXGoQk3lTgAeskQe3VWhKffUTG/gEeR+apFJRYD5d7QUC3WHjJkldiPVz2TSTAy5FJEn/pWCTYJwiOd+pZLOLlSU7OzuL819eRED4LEj+9rPRIk6eo4bScxGeOsEfiCUXZwhygEx9ye9/hC7tTF02SlwAAAABJRU5ErkJggg=="
  }))));
}

export default SvgPrint;